import apiClient from "../lib/apiClient";

/**
 * 파일 업로드 응답 DTO
 */
export interface UploadResponseDto {
  url: string;
  filename: string;
  mimetype: string;
  size: number;
}

/**
 * 상품 상세 이미지 업로드
 * - 경로: product/:productId/... (ProductService → StorageService, 강의 자료 등과 동일 패턴)
 * - POST /product/:productId/upload-image
 *
 * @param file - 업로드할 이미지 파일
 * @param productId - 상품 ID
 * @returns 업로드된 이미지 URL
 */
export const uploadContentImage = async (
  file: File,
  productId: number,
): Promise<string> => {
  const formData = new FormData();
  formData.append("image", file);

  const response = await apiClient.post<{ url: string }>(
    `/product/${productId}/upload-image`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
  return response.data.url;
};

